import moment from 'moment'
import {parsePrice} from './price.js'

interface RevenueRoute {
    startTime?: string
    endTime?: string
    plannedDuration?: number
}

interface RevenueOrder {
    price?: string
    removed?: boolean
}

/**
 * Revenue of a route as shown in the route info in Planning and returned by the Carrier API: the sum of the prices of
 * its orders (an order without a price counts as 0), divided by the executed duration in hours once the route has a
 * start and end time, otherwise by the planned duration. Without any duration the revenue per hour is 0.
 */
export function calculateRouteRevenue(route: RevenueRoute, orders: RevenueOrder[]): {revenue: number, revenuePerHour: number} {
    const revenue = orders.reduce((total, order) => order.removed ? total : total + parsePrice(order.price), 0)

    const durationExecuted = route.startTime && route.endTime ? moment(route.endTime).diff(moment(route.startTime), 'seconds') : 0
    const duration = durationExecuted || route.plannedDuration

    return {revenue, revenuePerHour: duration ? revenue / (duration / 3600) : 0}
}
